import { getValueFromLocalStorage } from '@/utils/getValueFromLocalStorage';
import { updateAppConfig } from './constants';

/**
 *  设置searchUrl，在所有逻辑之前
 */
export const setSearchUrl = async () => {
  const searchUrl = window.CsChat?.searchUrl;
  const locationSearch = window.location.search;
  let selectedSearchUrl = searchUrl || locationSearch;
  if (!selectedSearchUrl) {
    selectedSearchUrl = (await getValueFromLocalStorage('others.searchUrl')) || '';
  }

  if (!searchUrl) {
    window.CsChat = {
      ...(window.CsChat || {}),
      searchUrl: selectedSearchUrl,
    };
  }

  // [live-chat-split-change]
  const { default: firstInitStore } = await import('@/stores/firstInit');
  firstInitStore?.UPDATE_SEARCH_URL?.(selectedSearchUrl);

  // 重新生成配置
  updateAppConfig();
  return selectedSearchUrl;
};
